
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import './propertyWalkThroughForm.scss';
import './ConfigurePropertyWalkThrough.scss';
import './media.scss';

import { fetchPropertySuites } from '../../store/actions/suites';
import { selectSuites } from '../../store/selectors/suites';
import { setPropertyWalkThroughFormData, setPropertyWalkThroughFormNextStep, exitPropertyWalkThroughForm, saveConfigType, updateConfigType, saveCopyFromExisting, setPropertyWalkThroughFormStep } from '../../store/actions/propertyWalkThroughForm';
import Col from '../Col';
import Row from '../Row';
import Select from '../Select';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectPropertyWalkThroughFormData } from '../../store/selectors/propertyWalkThroughForm';
import Icon from '../Icon';
import File from '../File';
import { upload } from '../../helpers/upLoadHelper'
import { fetchAreasAndSubAreas, saveAssetConfig, deleteSubArea, saveSubAreaDescription } from '../../store/actions/areas';
import { selectWalkthroughSuites } from '../../store/selectors/WalkthroughSuites';
import { setEasyWalkThroughFormData, exitEasyWalkThroughForm } from '../../store/actions/easyWalkThroughForm';
import classNames from 'classnames';
import Loader from '../Loader';
import { saveArea } from '../../services/client';
import { variables } from '../../Tenants';
import { onCheckHeicDocument } from '../../helpers/CommonHelpers';

class ConfigurePropertyWalkThrough extends Component {

  constructor(props) {
    super(props)
    this.state = {
      selectionArray: []
    }
  }

  componentDidMount() {
    const { onFetchAreasAndSubAreas, walkthroughtSuites, onSetPropertyWalkThroughFormData, propertyWalkThroughFormData } = this.props;
    
    onFetchAreasAndSubAreas(propertyWalkThroughFormData.walkthroughId);
      if (walkthroughtSuites.length === 0) {
      if (!(propertyWalkThroughFormData.configTypeEdit && propertyWalkThroughFormData.configTypeEdit != '')) {
        onSetPropertyWalkThroughFormData({
          configType: 'Create New',
          copyFromSuiteId: null,
          description: null,
          embed: '',
          selectedImage: null,
          checkList:null
        })
      }
    }
   onSetPropertyWalkThroughFormData({ checkListValue: '' })
  }

  componentWillMount() {
    let data = this.props.propertyWalkThroughFormData;
    let selectionData = this.state.selectionArray;
    if (data && data.configTypeSaved && data.configTypeSaved.walkThroughMedia && data.configTypeSaved.walkThroughMedia.length > 0) {
      let selectionObj = data.configTypeSaved.walkThroughMedia;
      selectionObj.map((item, i) => {
        selectionData.push(item)
      })
      this.setState({ selectionArray: selectionData })
    }
  }
  handleMultipleUpload = async (selectedImage, callback) => {
    let uploadImages = [];
    for (let i = 0; i < selectedImage.length; i++) {
      if (selectedImage[i] && selectedImage[i].id) {
        uploadImages.push(selectedImage[i])
      } else {
        await this.uploadimg(selectedImage[i], (imgData) => {
          uploadImages.push(imgData);
        });
      }
    }
    callback(uploadImages)
  }

  // function to upload the images into aws
  uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile)
    let object = {
      Name: imageUrl.split('.com/')[1],
      URL: imageUrl
    }
    callback(object);
  }


  handleAddCheckList() {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } = this.props;
    let checkList = propertyWalkThroughFormData.checkList ? propertyWalkThroughFormData.checkList : [];
    if (propertyWalkThroughFormData.checkListValue && propertyWalkThroughFormData.checkListValue.trim().length > 0) {
      checkList = [...checkList, { description: propertyWalkThroughFormData.checkListValue }]
      onSetPropertyWalkThroughFormData({ checkList: checkList, checkListValue: '', edited: true })
    }
    else {
      onSetPropertyWalkThroughFormData({ checkListValue: '' })
    }
  }
  handleEditCheckList (e, item, i) {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } = this.props;
    let checkList = propertyWalkThroughFormData.checkList;
    checkList = checkList.map((cl, index) => {
      if(index === i) {
        return {...cl, description: e.target.value}
      } else {
        return cl
      }
    })
    onSetPropertyWalkThroughFormData({ checkList: checkList })
  }
  handleDeleteCheckList(item, i) {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } = this.props;

    let deletedCheckList = propertyWalkThroughFormData.deletedCheckList && propertyWalkThroughFormData.deletedCheckList.length > 0 ? propertyWalkThroughFormData.deletedCheckList : []
    if (item.id) {
      item = { ...item, isDeleted: true }
      deletedCheckList = [item, ...deletedCheckList]
    }
    let checkList = propertyWalkThroughFormData.checkList;
    if (item.id) {
      checkList = checkList.filter(i => i.id !== item.id)
    } else {
      checkList = checkList.filter((data, index) => index !== i);
    }

    onSetPropertyWalkThroughFormData({ checkList, deletedCheckList, edited: true, checkListValue: '' })
  }

  handleNext = async () => {
    const { onSetPropertyWalkThroughFormData, propertyWalkThroughFormData, user, onSaveCopyFromExisting, onUpdateConfigType } = this.props;
    let { description, suiteId, selectedImage, title, checkList, checkListValue } = propertyWalkThroughFormData;
    if (checkListValue !== '') {
      if (checkList && checkList.length > 0) {
        checkList = [...checkList, { description: propertyWalkThroughFormData.checkListValue }]
      } else {
        checkList = [
          {
            description: propertyWalkThroughFormData.checkListValue
          }
        ]
      }
    }
    onSetPropertyWalkThroughFormData({ checkListValue: '', edited: false })
    if (propertyWalkThroughFormData.deletedCheckList && propertyWalkThroughFormData.deletedCheckList.length > 0) {
      checkList = [...checkList, ...propertyWalkThroughFormData.deletedCheckList]
    }
    onSetPropertyWalkThroughFormData({ checkList })
    let params = {
      'Title': title,
      "Description": description,
      "SuiteId": suiteId,
      "Userid": user.id,
      "WalkThroughMedia": [],
      "WalkthroughChecklistItems": checkList && checkList.length > 0 ? checkList : []
    }

    if (selectedImage && selectedImage.length > 0) {
      onSetPropertyWalkThroughFormData({ isloading: true })      
      await this.handleMultipleUpload(selectedImage, function (resObj) {
        let files = (propertyWalkThroughFormData.deletedFiles && propertyWalkThroughFormData.deletedFiles.length > 0) ? [...resObj, ...propertyWalkThroughFormData.deletedFiles] : resObj        
        params = { ...params, WalkThroughMedia: files }
        onSetPropertyWalkThroughFormData({ selectedImage: null, deletedFiles: null, isloading: false })
        if (propertyWalkThroughFormData.FromWalkthroughsId) {
          params = {
            ...params,
            SuiteId: propertyWalkThroughFormData.FromSuiteId,
            FromWalkthroughsId: propertyWalkThroughFormData.FromWalkthroughsId,
            ToWalkthroughsId: propertyWalkThroughFormData.walkthroughId
          }
          onSetPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: true })
          onSaveCopyFromExisting(params)
        } else {
          params = {...params, id: propertyWalkThroughFormData.walkthroughId }
          onUpdateConfigType(params)
        }
      })
    } else if (propertyWalkThroughFormData.embed !== '' && propertyWalkThroughFormData.embed) {
      let files = propertyWalkThroughFormData.deletedFiles && propertyWalkThroughFormData.deletedFiles.length > 0 ?  propertyWalkThroughFormData.deletedFiles : [];
      let embedData = {
        type: "Embed",
        URL: propertyWalkThroughFormData.embed,
      }
      params = {...params, WalkThroughMedia: [...files, embedData]}

      if (propertyWalkThroughFormData.FromWalkthroughsId) {
        params = {
          ...params,
          SuiteId: propertyWalkThroughFormData.FromSuiteId,
          FromWalkthroughsId: propertyWalkThroughFormData.FromWalkthroughsId,
          ToWalkthroughsId: propertyWalkThroughFormData.walkthroughId
        }
        onSetPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: true })
        onSaveCopyFromExisting(params)
      } else {
        params = {...params, id: propertyWalkThroughFormData.walkthroughId }
        onUpdateConfigType(params)
      }
    } else {
      let files = propertyWalkThroughFormData.deletedFiles && propertyWalkThroughFormData.deletedFiles.length > 0 ?  propertyWalkThroughFormData.deletedFiles : []      
      params = { ...params, WalkThroughMedia: files }
      onSetPropertyWalkThroughFormData({ selectedImage: null, deletedFiles: null, isloading: false })
      if (propertyWalkThroughFormData.FromWalkthroughsId) {
        params = {
          ...params,
          SuiteId: propertyWalkThroughFormData.FromSuiteId,
          FromWalkthroughsId: propertyWalkThroughFormData.FromWalkthroughsId,
          ToWalkthroughsId: propertyWalkThroughFormData.walkthroughId
        }
        onSetPropertyWalkThroughFormData({ copyFromSuiteIdApiCalling: true })
        onSaveCopyFromExisting(params)
      } else {
        params = {...params, id: propertyWalkThroughFormData.walkthroughId }
        onUpdateConfigType(params)
      }
    }
  }


  inputFeilds1() {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } = this.props;
    return (
      <div class="input_box">
        <div class="input_section">
          <input class="form-control" type="text" placeholder="Title*" aria-label="default input example"
            value={propertyWalkThroughFormData.title}
            onChange={e => onSetPropertyWalkThroughFormData({ title: e.target.value })}
            required
          />
        </div>
        <div class="input_section">
          <div class="form-floating">
            <textarea class="form-control" placeholder="Description" id="floatingTextarea2"
              style={{ height: '200px' }}
              onChange={e => onSetPropertyWalkThroughFormData({ description: e.target.value })}
              value={propertyWalkThroughFormData.description}
            ></textarea>
          </div>
        </div>
        <div class="input_section mt-20">
          <label for="">Check List</label>
          {propertyWalkThroughFormData.checkList && propertyWalkThroughFormData.checkList.length > 0 ?
            propertyWalkThroughFormData.checkList.map((item, i) => item.isDeleted !== true ?
              <div class="mainDiv">
                <div class="w-93">
                  <input class="form-control" type="text" placeholder="Enter Check List" aria-label="default input example"
                    value={item.description}
                    onChange={e => this.handleEditCheckList(e, item, i)}
                  />
                </div>
                <div class="w-7">
                  <a class="closeBtn"  style={{cursor:'pointer'}} onClick={() => this.handleDeleteCheckList(item, i)}>
                    <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M0.258279 0.580619C0.404791 0.434106 0.603506 0.351796 0.810706 0.351796C1.01791 0.351796 1.21662 0.434106 1.36313 0.580619L4.67769 3.89518L7.99225 0.580619C8.13876 0.434106 8.33748 0.351796 8.54468 0.351796C8.75188 0.351796 8.95059 0.434106 9.0971 0.580619C9.24361 0.727132 9.32592 0.925845 9.32593 1.13305C9.32593 1.34025 9.24361 1.53896 9.0971 1.68547L5.78254 5.00003L9.0971 8.31459C9.24361 8.4611 9.32593 8.65982 9.32593 8.86702C9.32592 9.07422 9.24361 9.27293 9.0971 9.41944C8.95059 9.56595 8.75188 9.64826 8.54468 9.64827C8.33748 9.64826 8.13876 9.56595 7.99225 9.41944L4.67769 6.10488L1.36313 9.41944C1.21662 9.56595 1.01791 9.64827 0.810706 9.64826C0.603506 9.64826 0.404791 9.56595 0.258279 9.41944C0.111766 9.27293 0.0294564 9.07422 0.0294564 8.86702C0.0294565 8.65982 0.111766 8.4611 0.258279 8.31459L3.57284 5.00003L0.258279 1.68547C0.111766 1.53896 0.0294565 1.34025 0.0294564 1.13305C0.0294564 0.925845 0.111766 0.727132 0.258279 0.580619Z" fill="black"></path></svg>
                  </a>
                </div>
              </div>
              : null) : null}

          <div class="mainDiv">
            <div class="">
              <input class="form-control" type="text" placeholder="Enter Check List" aria-label="default input example"
                value={propertyWalkThroughFormData.checkListValue}
                onChange={e => onSetPropertyWalkThroughFormData({ checkListValue: e.target.value, edited: true })}
              />
            </div>  
            <div class="">
             <button className='btnchecklist' onClick={() => this.handleAddCheckList()}> + Add New Row</button>
            </div>          
          </div>
        </div>

        <div class="input_section mt-20 mediaLabel">
          <File
            label=""
            onSelect={(file) =>
            onCheckHeicDocument(file) &&  this.selectMultipleItems(file)
            }
            files={[]}
            multiSelect={true}
          />
        </div>
        <div class="input_section">
          <div class="or_box">
            <div class="line_box"></div>
            <p>OR</p>
            <div class="line_box"></div>
          </div>
        </div>
        <div class="input_section" style={{ marginBottom: 20 }}>
          <div class="form-floating">
            <textarea class="form-control" placeholder="Embed" id="floatingTextarea2"
              value={propertyWalkThroughFormData.embed}
              onChange={e => onSetPropertyWalkThroughFormData({ embed: e.target.value })}
            ></textarea>
          </div>
        </div>

        {propertyWalkThroughFormData.selectedImage && propertyWalkThroughFormData.selectedImage.length > 0 ?
          propertyWalkThroughFormData.selectedImage.map((data, i) => (data.id && data.isDeleted === true) ? null :

            <Row
              mdCenter >
              <Col
                granola
                xs="6"
                md="6"
              >
                {data && data.path ? data.path : data.type && data.type === 'Embed' ? 'Embed' : data.name}
              </Col>

              <Col granola xs='1' md='1'>
                <div onClick={() => this.handleDelete(data)}>
                  <Icon
                    glyph="times-circle"
                    weight="light"
                    size="small"
                  />
                </div>
              </Col>
            </Row>

          ) : null}
      </div>
    )
  }

  selectMultipleItems = (files) => {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } = this.props;
    if (propertyWalkThroughFormData.selectedImage && propertyWalkThroughFormData.selectedImage.length > 0) {
      let selectedImage = propertyWalkThroughFormData.selectedImage
      for (var i = 0; i < selectedImage.length; i++) {
        if (selectedImage[i].id) {

        } else {
          for (var j = 0; j < files.length; j++) {
            if (files[j].name === selectedImage[i].name) {

              files.splice(j, 1)

            }
          }
        }

      }


      onSetPropertyWalkThroughFormData({ selectedImage: [...files, ...selectedImage] })
    } else {
      onSetPropertyWalkThroughFormData({ selectedImage: files })
    }
  }



  handleDelete(item) {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } = this.props;
    let selectedImage = propertyWalkThroughFormData.selectedImage;


    let deletedFiles = propertyWalkThroughFormData.deletedFiles ? propertyWalkThroughFormData.deletedFiles : [];
    if (item.id) {
      item = { ...item, isDeleted: true }
      deletedFiles = [item, ...deletedFiles]
    }

    selectedImage = propertyWalkThroughFormData.selectedImage.filter(data => data && data.id ? (data.id !== item.id) : data !== item)
    onSetPropertyWalkThroughFormData({ selectedImage, deletedFiles })
  }
  handleWalkthroughSuite(id) {
    const { walkthroughtSuites, onSetPropertyWalkThroughFormData } = this.props;
    let data = walkthroughtSuites.filter(item => item.walkthroughId === id)
    if (data.length > 0) {
      onSetPropertyWalkThroughFormData({
        FromWalkthroughsId: data[0].walkthroughId,
        FromSuiteId: data[0].id,
        title: data[0].title,
        description: data[0].description,
        selectedImage: data[0].walkThroughMedia,
        checkList:data[0].walkthroughChecklistItems,
      })
    }


  }
  render() {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData, onExitEasyWalkThroughForm, onSetPropertyWalkThroughFormNextStep, onFetchPropertySuites, onExitPropertyWalkThroughForm, onClose, user, suites, walkthroughtSuites } = this.props;
    const { propertyName, suiteName } = propertyWalkThroughFormData;
  
    return (
      <>
        <div class="header_section">
          {(propertyWalkThroughFormData.copyFromSuiteIdApiCalling && propertyWalkThroughFormData.copyFromSuiteIdApiCalling === true) || propertyWalkThroughFormData.isloading ? <Loader center={true} /> : null}
          <div class="header_box">
            <div class="header_back_btn">
              <div class="back_arrow" onClick={() => {
                onFetchPropertySuites(propertyWalkThroughFormData.propertyId, user.id, user.roles[0].role.name)
                onExitPropertyWalkThroughForm()
                onExitEasyWalkThroughForm()
                if (onClose) onClose();
              }}>
                <a href="#.">
                  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M21 7.71429V10.2857H5.25L10.5 15.4286L9.1875 18L0 9L9.1875 0L10.5 2.57143L5.25 7.71429H21Z"
                      fill="#1D1D1D"
                       />
                  </svg>
                </a>
              </div>
            </div>
            <div class="configure_heading">
              <h2>Configure Walk Through</h2>
            </div>
            <div class="next_btn text-right" style={{ pointerEvents: (!propertyWalkThroughFormData.title || !propertyWalkThroughFormData.description) && "none" }}
              onClick={() => this.handleNext()}>
              <a href="#." style={{backgroundColor:'whitesmoke',color:'black',border:'1px solid whitesmoke',borderRadius:'5px'}}>Next</a>
            </div>
          </div>
        </div>
        <div class="avenue_section ConfigureWalkThroughHead">
          <div class="avenue_main_box">
            <div class="avenue_heading">
              <h4>{propertyName + ', ' + suiteName}</h4>
            </div>
            {propertyWalkThroughFormData.configTypeEdit && propertyWalkThroughFormData.configTypeEdit != '' ? null : walkthroughtSuites.length > 0 ?
              <div class="btn_box">
                <div class="button_section">
                  <div class="create_new_btn"
                    onClick={e => onSetPropertyWalkThroughFormData({ configType: 'Create New', copyFromSuiteId: null, description: null, selectedImage: null,checkList:null,FromWalkthroughsId:null })}
                  >
                    <a href="#">
                      + Create New
                        </a>
                  </div>
                  <div class="copy_btn"
                    onClick={e => onSetPropertyWalkThroughFormData({ configType: 'Copy From Existing', copyFromSuiteId: null, description: null, selectedImage: null ,checkList:null,FromWalkthroughsId:null })}
                  >
                    <a href="#.">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M16.4 17.0001H6.6C6.44087 17.0001 6.28826 16.9368 6.17574 16.8243C6.06321 16.7118 6 16.5592 6 16.4001V6.60006C6 6.44093 6.06321 6.28832 6.17574 6.1758C6.28826 6.06327 6.44087 6.00006 6.6 6.00006H16.4C16.5591 6.00006 16.7117 6.06327 16.8243 6.1758C16.9368 6.28832 17 6.44093 17 6.60006V16.4001C17 16.5592 16.9368 16.7118 16.8243 16.8243C16.7117 16.9368 16.5591 17.0001 16.4 17.0001Z"
                          stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                          d="M12 6.00006V1.60006C12 1.44093 11.9368 1.28832 11.8243 1.1758C11.7117 1.06328 11.5591 1.00006 11.4 1.00006H1.6C1.44087 1.00006 1.28826 1.06328 1.17574 1.1758C1.06321 1.28832 1 1.44093 1 1.60006V11.4001C1 11.5592 1.06321 11.7118 1.17574 11.8243C1.28826 11.9368 1.44087 12.0001 1.6 12.0001H6"
                          stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Copy From Existing
                        </a>
                  </div>
                </div>
              </div>
              : null}
          </div>
          {propertyWalkThroughFormData.configType ?
            propertyWalkThroughFormData.configType === 'Create New' ?
              this.inputFeilds1() : propertyWalkThroughFormData.FromWalkthroughsId ?
                this.inputFeilds1() : (
                  <div class="input_box">
                    <div class="input_section">
                      <Select
                        value={propertyWalkThroughFormData.FromWalkthroughsId ? propertyWalkThroughFormData.FromWalkthroughsId : ''}
                        label={`Choose ${variables.Suite}`}
                        placeholder="Select"
                        onChange={e =>
                          this.handleWalkthroughSuite(e.target.value)
                        }
                        options={walkthroughtSuites.map(suite => ({ label: suite.number, value: suite.walkthroughId }))}
                      />
                    </div>
                  </div>
                ) : null}

        </div>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    suites: selectSuites(state),
    propertyWalkThroughFormData: selectPropertyWalkThroughFormData(state),
    user: selectAuthenticatedUser(state),
    walkthroughtSuites: selectWalkthroughSuites(state)
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
  onSetPropertyWalkThroughFormNextStep: setPropertyWalkThroughFormNextStep,
  onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
  onSaveConfigType: saveConfigType,
  onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
  onSaveCopyFromExisting: saveCopyFromExisting,
  onUpdateConfigType: updateConfigType,
  onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,
  onFetchPropertySuites: fetchPropertySuites,
  onExitEasyWalkThroughForm: exitEasyWalkThroughForm,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurePropertyWalkThrough);